export function getCookie(key: string) {
  const reKey = new RegExp(`(?:^|; )${key}(?:=([^;]*))?(?:;|$)`)
  const match = reKey.exec(document.cookie)
  return match ? match[1] : null
}

export function setCookie(key: string, value: string, expDays: number = 365) {
  const date = new Date()
  const year = expDays * 24 * 60 * 60 * 1000
  date.setTime(date.getTime() + year)
  document.cookie = `${key}=${value}; expires=${date}; path=/; domain=${window.location.hostname}`
}

export function setCookieResistant(
  key: string,
  value: string,
  expDays: number = 365,
) {
  const date = new Date()
  const year = expDays * 24 * 60 * 60 * 1000
  date.setTime(date.getTime() + year)
  // Set cookie with attributes that make it less likely to be removed by CookieYes
  // SameSite=Strict and Secure flags help prevent automatic removal
  const secure = window.location.protocol === 'https:'
  // Use the parent domain to ensure consistency across subdomains
  const domain = window.location.hostname.startsWith('www.')
    ? window.location.hostname.substring(3) // Remove 'www.' to get parent domain
    : window.location.hostname
  document.cookie = `${key}=${value}; expires=${date.toUTCString()}; path=/; domain=.${domain}; SameSite=Strict${secure ? '; Secure' : ''}`
}

export function removeCookie(key: string) {
  const expires = new Date(0).toUTCString()
  document.cookie = `${key}=; expires=${expires}; path=/; domain=${window.location.hostname}`
}
